import React, {ChangeEvent, Component, ReactNode} from 'react'
import {HOURS, RESERVATION_TIME_UNIT_MINUTES} from '../../../CodeMaster'
import {Nullable} from '../../../app/TypeHelpers'
import {addEmptyData, isNoSelect, valueOrNoSelected} from '../../../componentHelper/selectHelper'
import DisplayItemSelectComponent from '../../../styledComponents/DisplayItemSelectComponent'
import {FlexContainer, StretchRowFlexContainer} from '../../../styledComponents/FlexComponents'
import {BlockSpacerPcOnly} from '../../../styledComponents/ResponsiveConvenience'
import { Box } from '@mui/material';

interface Props {
    hour: Nullable<HOURS>,
    minute: Nullable<RESERVATION_TIME_UNIT_MINUTES>,
    onChange: (hour: Nullable<HOURS>, minute: Nullable<RESERVATION_TIME_UNIT_MINUTES>) => void,
    disabled?: boolean
    hassError?: boolean
}

class TimePickerForResident extends Component<Props> {
    constructor(props: Readonly<Props>) {
        super(props)

        this.handleChangeHour = this.handleChangeHour.bind(this)
        this.handleChangeMinute = this.handleChangeMinute.bind(this)
    }

    handleChangeHour(event: ChangeEvent<HTMLSelectElement>): void {
        const value: string = `${event.target.value}`
        this.props.onChange(
            isNoSelect(value) ? null : HOURS.codeToEnumConstants(value),
            this.props.minute,
        )
    }

    handleChangeMinute(event: ChangeEvent<HTMLSelectElement>): void {
        const value: string = `${event.target.value}`
        this.props.onChange(
            this.props.hour,
            isNoSelect(value) ? null : RESERVATION_TIME_UNIT_MINUTES.codeToEnumConstants(value),
        )
    }

    render(): ReactNode {
        const {hour, minute, disabled} = this.props
        const selectableHours = hour ? HOURS.values() : addEmptyData(HOURS.values(), '時')
        const selectableMinutes = minute
            ? RESERVATION_TIME_UNIT_MINUTES.values()
            : addEmptyData(RESERVATION_TIME_UNIT_MINUTES.values(), '分')
        return <>
            <FlexContainer>
                <FlexContainer>
                    <BlockSpacerPcOnly width={20}/>
                </FlexContainer>
                <DisplayItemSelectComponent
                    onChange={this.handleChangeHour} value={valueOrNoSelected(hour)}
                    disabled={disabled} hasError={this.props.hassError}
                >
                    {
                        selectableHours.map((item, index) => {
                            return <option key={index} value={item.value}>{item.label}</option>
                        })
                    }
                </DisplayItemSelectComponent>
                <StretchRowFlexContainer>
                    <Box display={'flex'} width={18} minWidth={18} alignItems={'center'}
                         justifyContent={'center'}>：</Box>
                </StretchRowFlexContainer>
                <DisplayItemSelectComponent
                    onChange={this.handleChangeMinute} value={valueOrNoSelected(minute)}
                    disabled={disabled} hasError={this.props.hassError}
                >
                    {
                        selectableMinutes.map((item, index) => {
                            return <option key={index} value={item.value}>{zeroPadding(item.label)}</option>
                        })
                    }
                </DisplayItemSelectComponent>
            </FlexContainer>
        </>
    }
}

function zeroPadding(value: string): string {
    if (!value.match(/^\d+$/)) {
        return value
    }
    return `0${value}`.substr(-2)
}

export default TimePickerForResident
